import { Injectable } from '@angular/core';
import { BaseTableService } from './base-table.service';
import { ExternalContactList } from 'src/app/model/contacts/external-contact-list';

@Injectable({
  providedIn: 'root',
})
export class ExternalContactListTableService extends BaseTableService<ExternalContactList> {
  constructor() {
    super();
  }
}
